<template>
  <div class="app-container">
    <!-- <div class="index-tree-box">
      <type-tree ref="type_tree" @on-select="onSelect" @title-click="titleClick" />
      <div class="right-box"> -->
        <list ref="list">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <!-- <el-button type="success" plain @click="onImprot">导入</el-button> -->
            <el-button type="success" @click="onExport">导出</el-button>
            <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column label="操作" fixed="right" align="center" width="50">
              <template slot-scope="{row}">
                <el-button type="text" @click="edit(row)">编辑</el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      <!-- </div>
    </div> -->
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/demo/molduse/list";
import editDialog from "@/components/demo/molduse/editDialog";
import typeTree from "@/components/demo/molduse/type/tree";
import importDialog from "@/components/demo/molduse/importDialog";

export default {
  name: "record",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    typeTree,
    importDialog,
  },
  data() {
    return {
      
    };
  },
  // mounted() {
  //   this.$refs.type_tree.getData();
  // },
  methods: {
    onImprot() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
    // onSelect(data) {
    //   this.select.Id = data.ClassId;
    //   this.select.Name = data.ClassName;
    //   this.$refs.list.getData({ IdChain: data.IdChain });
    //   // this.reload();
    // },
    // titleClick() {
    //   this.select.Id = null;
    //   this.select.Name = "";
    //   this.$refs.list.getData({ IdChain: null });
    // },
    // create() {
    //   this.$refs.editDialog.openCreate({
    //     ClassId: this.select.Id,
    //     ClassName: this.select.Name,
    //   });
    // },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.MouldId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>